import { createFileRoute, useNavigate } from '@tanstack/react-router';
import * as React from 'react';
import { PERMISSION_TACHO_CORRECTION } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import Form from '../../components/Corrections/Form';
import { URL_CORRECTIONS } from '../../router/constants';

export const Route = createFileRoute('/_authenticated/corrections/add')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_TACHO_CORRECTION, ['create'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'table.add',
        suffix: 'menu.corrections',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: AddCorrectionRoute,
});

function AddCorrectionRoute() {
  const navigate = useNavigate();

  const handleClose = React.useCallback(() => {
    navigate({ to: URL_CORRECTIONS });
  }, [navigate]);

  return <Form id={null} customerId={null} handleClose={handleClose} />;
}
